import { Type } from 'class-transformer'
import { OwnerProfileDto } from '../common'

export class IdentificationPostRequest {
  authCode: string
  emailAddress: string

  constructor(email: string, authCode: string) {
    this.authCode = authCode
    this.emailAddress = email
  }
}

export const IDENTIFY_RESULT_CODE = {
  SUCCESS: 200,
  FORBIDDEN: 403,
} as const
export type IdentifyResultCode = typeof IDENTIFY_RESULT_CODE[keyof typeof IDENTIFY_RESULT_CODE]

export class IdentificationPostResponse {
  resultCode!:IdentifyResultCode
  @Type(() => OwnerProfileDto) profile?: OwnerProfileDto
  failedMessage?:string

  redirectTo?: string
  accessToken?: string

  requiredAdditionalIdentification?: boolean
}
